<template>
  <Container />
  <Footer />
</template>
<script setup>
import Container from '@/components/Container.vue';
</script>
<style src="~/styles/bootstrap2.css"></style>
<style src="~/styles/utilities.css"></style>